import React, { useContext, useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { postData } from "../services/API";
import { UserData } from "../contexts/UserInfoContext";
import Frame from "../components/DiscResult/Frame";
import Chart from "react-apexcharts";
import logo from "../images/header-logo.png";
import discImg from "../images/disc.png";
import person1 from "../images/person1.png";
import person2 from "../images/person2.png";
import discImg2 from "../images/chart-2.png";
import discImg3 from "../images/chart-3.png";
import discImg4 from "../images/chart-4.png";
import discImg5 from "../images/chart-5.png";
import discImg6 from "../images/chart-6.png";
import discImg7 from "../images/chart-7.png";
import discImg8 from "../images/chart-8.png";
import discImg9 from "../images/chart-9.png";
import discImg10 from "../images/chart-10.png";
import circle from "../images/circle.png";
import circle2 from "../images/circle-2.png";
import circle3 from "../images/circle-3.png";
import { toFarsiNumber } from "../helper/helper";
import { Link, useSearchParams } from "react-router-dom";
import ResultWrapper from "../UserPanel/ConsTests/disc/ResultWrapper";

const DiscResult = () => {
  const { user, userLoaded } = useContext(UserData);
  const [testResult, setTestResult] = useState({});
  const [loading, setLoading] = useState(true);
  const [once, setOnce] = useState(true);
  const [errMsg, setErrMsg] = useState({});
  const [searchParams, setSearchParams] = useSearchParams({});
  const id = searchParams.get("id");

  const printResult = useRef();

  useEffect(() => {
    const element = document.querySelector('meta[name="viewport"]');
    document.querySelector("body").style.backgroundColor = "#fff";
    element.setAttribute("content", "width=1024");
    if (once) {
      setOnce(false);
      if (id) {
        postData("/tests/get-app-test", { user_id: id })
          .then((res) => {
            setTestResult(res.data);
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
            setErrMsg(err.response.data);
          });
      } else {
        postData("/tests/check-test", { test: "disc" })
          .then((res) => {
            setTestResult(res.data);
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
            setErrMsg(err.response.data);
          });
      }
    }
  }, []);

  const handlePrint = useReactToPrint({
    content: () => printResult.current,
  });

  const circleChartOption = (color) => {
    const options = {
      series: [70],
      options: {
        colors: [color],
        track: {
          background: "#f8f9fa",
        },
        stroke: {
          lineCap: "round",
        },
        chart: {
          height: 350,
          type: "radialBar",
          background: "#fff",
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: "70%",
            },
          },
        },
        theme: {
          mode: "light",
        },
      },
    };

    return options;
  };

  const anlayse = {
    series: [
      {
        data: [10, 41, 35, 100],
      },
    ],
    options: {
      chart: {
        // height: 350,
        type: "line",
        zoom: {
          enabled: false,
        },
        background: "#fff",
      },
      colors: ["#fbc02d"],
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#fbc02d"],
            fontSize: "12px",
            fontWeight: "600",
          },
          background: {
            enabled: true,
            foreColor: "#fff",
            padding: 6,
            borderRadius: 6,
            borderWidth: 0,
            borderColor: "#fbc02d",
            opacity: 1,
            color: "#facc15",
          },
        },
      grid: {
        row: {
          colors: ["transparent", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
        yaxis: {
          lines: {
            show: false,
          },
        },
        borderColor: "#fbc02d",
      },
      markers: {
        size: 1,
      },
      yaxis: {
        min: 0,
        max: 100,
        tickAmount: 8,
        forceNiceScale: false,
        labels: {
          style: {
            colors: ["#222"],
            fontSize: "12px",
            fontWeight: "600",
          },
        },
      },
      xaxis: {
        categories: ["D", "I", "S", "C"],
        labels: {
          style: {
            colors: ["#222"],
            fontSize: "12px",
            fontWeight: "600",
          },
        },
      },
      theme: {
        mode: "light",
      },
      annotations: {
        yaxis: [
          { y: 0, borderColor: "#e5e7eb" },
          { y: 14.2857, borderColor: "#e5e7eb" },
          { y: 28.5714, borderColor: "#e5e7eb" },
          { y: 42.8571, borderColor: "#e5e7eb" },
          { y: 57.1429, borderColor: "#e5e7eb" },
          { y: 71.4286, borderColor: "#e5e7eb" },
          { y: 85.7143, borderColor: "#e5e7eb" },
          { y: 100, borderColor: "#e5e7eb" },
        ],
      },
    },
  };

  return (
    <div className="w-full min-h-screen h-auto flex flex-col gap-5 py-10 items-center overflow-x-hidden">
      {loading || !userLoaded ? (
        <span className="text-2xl font-black text-gray-800">
          لطفا صبر کنید...
        </span>
      ) : errMsg?.message ? (
        <span className="text-2xl font-black text-red-600">
          {errMsg?.message}
        </span>
      ) : (
        <>
          <button
            onClick={handlePrint}
            className="w-32 h-11 self-center flex justify-center items-center rounded-xl font-black text-white bg-gradient-to-tl from-green-700 to-green-400"
          >
            دانلود پی دی اف
          </button>
          <div
            ref={printResult}
            className="printer-wrapper disc-print flex flex-col w-fit h-fit"
          >
            {/* page 1 */}
            <div
              style={{ breakAfter: "page" }}
              className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
            >
              {/* frame */}
              <Frame page={1} user={testResult?.app ? testResult.app : user} />

              {/* design */}
              <div className="w-full bg-gray-200 relative h-80 z-30 flex justify-center items-center">
                <div className="size-44 border-2 bg-gray-200 relative z-10 border-dotted border-gray-800 rounded-full flex items-center justify-center">
                  <img src={logo} className="w-36 mt-4" alt="" />
                </div>

                <div className="w-2/4 h-1 border-t-2 border-gray-800 border-dotted absolute left-0"></div>

                <div className="w-20 h-full bg-yellow-700 absolute right-10"></div>

                <div className="w-full flex justify-center flex-col gap-4 absolute -bottom-48">
                  <div className="flex justify-center items-center flex-row-reverse gap-6">
                    <div className="bg-red-700 w-28 h-28 border-[6px] border-gray-200"></div>
                    <div className="bg-yellow-700 w-28 h-28 border-[6px] border-gray-200"></div>
                    <div className="bg-green-700 w-28 h-28 border-[6px] border-gray-200"></div>
                    <div className="bg-blue-700 w-28 h-28 border-[6px] border-gray-200"></div>
                  </div>

                  <div className="flex justify-center items-center flex-row-reverse gap-6">
                    <div className="text-red-700 flex items-start justify-center text-9xl font-bold w-28 h-28 border-[6px] border-gray-200">
                      D
                    </div>
                    <div className="text-yellow-700 flex items-start justify-center text-9xl font-bold w-28 h-28 border-[6px] border-gray-200">
                      I
                    </div>
                    <div className="text-green-700 flex items-start justify-center text-9xl font-bold w-28 h-28 border-[6px] border-gray-200">
                      S
                    </div>
                    <div className="text-blue-700 flex items-start justify-center text-9xl font-bold w-28 h-28 border-[6px] border-gray-200">
                      C
                    </div>
                  </div>
                </div>
              </div>

              {/* user info */}
              <div className="w-full h-auto pr-36">
                <div className="w-full bg-gray-200 mt-44 relative p-5">
                  <div className="w-24 h-full bg-yellow-700 absolute left-24 top-0"></div>

                  <div className="w-96 h-full flex flex-col border border-gray-800">
                    <div className="border-b border-gray-700 p-4 text-gray-800">
                      نام و نام خانوادگی :{" "}
                      {testResult?.app
                        ? testResult.app?.user?.name +
                          " " +
                          testResult.app?.user?.family_name
                        : user?.user?.name + " " + user?.user?.family_name}
                    </div>
                    <div className="border-b border-gray-700 p-4 text-gray-800">
                      مشاور :{" "}
                      {testResult.app
                        ? testResult.app?.cons?.name +
                          " " +
                          testResult.app?.cons?.family_name
                        : "مشاور انتخاب نشده"}
                    </div>
                    <div className="border-b border-gray-700 p-4 text-gray-800">
                      تاریخ :{" "}
                      {testResult.time
                        ? new Intl.DateTimeFormat("fa-IR", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          }).format(new Date(testResult.time))
                        : "ثبت نشده"}
                    </div>

                    <div className="p-4 text-gray-800">نوع آزمون : دیسک</div>
                  </div>
                </div>
              </div>
            </div>

            {/* page 2 */}
            <div
              style={{ breakAfter: "page" }}
              className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
            >
              {/* frame */}
              <Frame page={2} user={testResult?.app ? testResult?.app : user} />

              <div className="w-full flex flex-col gap-4 p-10 pt-32">
                <p className="text-gray-700 px-10">
                  از اﯾنکه پرﺳﺸﻨﺎﻣﻪ دﯾسک بین المللی را در یونی بست ، تکمیل
                  ﻧﻤﻮدﯾﺪ از ﺷﻤﺎ سپاسگزارﯾﻢ اﻣﯿﺪوارﯾﻢ که در ﻣﺴﯿر خود ارزیابی ،
                  ﺧﻮدآگاهی و هدایت شغلی / ﻓﺮدی ، ﺧﻮد ﻣﻮﻓﻖ ﺑﺎﺷﯿﺪ.
                </p>

                <h2 className="text-3xl text-gray-800 font-black self-center my-3">
                  تست DISC دیسک چیست؟
                </h2>

                <p className="text-gray-700">
                  تست دیسک یکی از مشهورترین آزمون های مدیریتی و خودارزیابی است ،
                  که بسیاری از سازمان ها برای رفتارشناسی و شناخت کارکنان از آن
                  استفاده می کنند . نام DISC مخفف چهار سبک اصلی است که سیستم
                  رفتارشناسی DISC را تشکیل می دهند .رفتار هر شخص ترکیبی از این
                  چهار سبک می باشد :
                </p>

                <img src={discImg} className="col-span-2" alt="" />
              </div>
            </div>

            {/* page 3 */}
            <div
              style={{ breakAfter: "page" }}
              className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
            >
              {/* frame */}
              <Frame page={3} user={testResult?.app ? testResult.app : user} />

              <div className="w-full flex flex-col gap-4 p-10 pt-28">
                <h2 className="text-3xl text-gray-800 font-black self-center my-3">
                  کاربردهای تست دیسک
                </h2>

                <p className="text-gray-700">
                  زمینه‌های استفاده از تست دیسک بسیار گسترده ا‌ست. برای مثال در
                  زمینه توسعه فردی و رسیدن به رضایت شغلی، که بحث اصلی مطالب
                  ماست، به خوبی می‌شود از نتایج تست رفتارشناسی دیسک استفاده کرد
                  . دیسک می تواند به شناخت سریع رفتارهایمان برای تغییر کمک زیادی
                  کند . مهمترین کاربردهای این تست عبارتند از :
                </p>

                <div className="w-full grid grid-cols-8 gap-4 place-content-center justify-center place-items-center">
                  <img src={person1} className="col-span-2" alt="" />
                  <p className="text-gray-700 text-sm leading-7 col-span-4 text-justify">
                    حل تعارض و مشکلات بین فردی انتخاب رشته و مسیر حرفه ای توسعه
                    مهارت های فروش پیدا کردن جایگاه شغلی افزایش مدیریت موثر
                    افزایش خودآگاهی بهبود تیم سازی
                  </p>
                  <img src={person2} className="col-span-2" alt="" />
                </div>

                <p className="text-gray-700 mt-3">
                  شما با توجه به آزمون دیسک متوجه می‌شوید در کدام یک از چهار
                  مولفه، نمره بالا و در کدام یک نمره پایینی دارید. از آن‌جایی که
                  همه‌ی چهار مولفه رفتاری دیسک مطلوب هستند، ما باید سعی کنیم به
                  حد تعادل نزدیک شده
                </p>

                <p className=" text-gray-800 text-lg font-black mt-4">
                  برایان تریسی : ما به هیچ وجه بدون گرفتن آزمون دیسک کسی را در
                  شرکتمان استخدام نمیکنیم . آنتونی رابینز ، معتقد است که آزمون
                  دیسک ارزیابی ارزشمند جهت درک رفتار خود است و در شرکت خودش از
                  این ارزیابی استفاده می‌کند .
                </p>
              </div>
            </div>

            {/* page 4 */}
            <div
              style={{ breakAfter: "page" }}
              className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
            >
              {/* frame */}
              <Frame page={4} user={testResult?.app ? testResult.app : user} />

              <div className="w-full flex flex-col gap-4 p-10 pt-28">
                <h2 className="text-3xl text-gray-800 font-black self-center my-3">
                  الگوهای متداول در دیسک بین المللی
                </h2>

                <p className="text-gray-700 px-20 text-center">
                  پراکندگی تیپ‌های آزمون DISC تقریبا یکسان است؛ به این معنی که
                  هر کدام از تایپ‌ها، 25% از جمعیت را تشکیل می‌دهند.
                </p>

                <img src={discImg2} className="self-center px-16 mt-5" alt="" />
              </div>
            </div>

            {/* page 5 */}
            <div
              style={{ breakAfter: "page" }}
              className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
            >
              {/* frame */}
              <Frame page={5} user={testResult?.app ? testResult.app : user} />

              <div className="w-full flex flex-col gap-4 p-10 pt-28">
                <h2 className="text-3xl text-gray-800 font-black self-center my-3">
                  الگوهای متداول در دیسک بین المللی
                </h2>

                <img src={discImg3} className="self-center px-16 mt-5" alt="" />
              </div>
            </div>

            {/* page 6 */}
            <div
              style={{ breakAfter: "page" }}
              className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
            >
              {/* frame */}
              <Frame page={6} user={testResult?.app ? testResult.app : user} />

              <div className="w-full flex flex-col gap-4 p-10 pt-28">
                <h2 className="text-3xl text-gray-800 font-black self-center my-3">
                  شاخص ابعاد DISC دیسک
                </h2>

                <img src={discImg4} className="self-center px-16 mt-5" alt="" />
              </div>
            </div>

            {/* page 7 */}
            <div
              style={{ breakAfter: "page" }}
              className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
            >
              {/* frame */}
              <Frame page={7} user={testResult?.app ? testResult.app : user} />

              <div className="w-full flex flex-col gap-4 p-10 pt-28">
                <h2 className="text-3xl text-gray-800 font-black self-center my-3">
                  توصیف شاخص ابعاد DISC
                </h2>

                <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
                  <div className="w-full h-auto border overflow-hidden border-red-700 rounded-xl flex flex-col gap-3">
                    <h3 className="text-white bg-red-700 font-bold text-lg text-center py-3 border-b border-red-600">
                      بعد تسلط : D
                    </h3>

                    <p className="text-gray-700 text-sm leading-6 p-3 pt-0 text-justify">
                      اگر هدف شما دریافت جواب ها و شیوه های بهتر و نوین باشد ،
                      کنجکاوی نقطه مثبتی است ولی تکرار آن باعث رکود درکار های
                      تان و کناره گیری افراد گروه می شود. - خاطرجمع - اطمینان به
                      قابلیت های تان ، شما را رهبری موفق جلوه می دهد. ولی افراط
                      در این ویژگی شما را سرخود و یک دنده معرفی می کند. - برتری
                      جو - صرف انرژی جهت برنده شدن ، بهتر شدن و تفکر در این حوزه
                      به شرط توجه به اخلاق حرفه ای و بازی برد برد ، ویژگی قابل
                      ستایش شماست. - متفکر سریع - سرعت در فهم مسائل پیچیده و
                      پردازش تفکرات یکی از ویژگی های بارز شماست ، لذا برای کنترل
                      این ویژگی باید تمایل خود به تصمیم گیری سریع را تعدیل کرده
                      تا شما را فردی بی توجه به خطرات تلقی نکنند. - مستقل -
                      استقلال فکری شما ویژگی ممتازی در شرایط بحرانی، برای رهبری
                      گروه است. مشروط بر این که اصرار بر این ویژگی موجب شکاف در
                      اعضای گروه نشود. - ریسک پذیر حساب گر - این ویژگی مثبتی
                      برای شما به منظور کاهش مخاطرات ، آسیب ها و شکست ها می باشد
                      به شرط این که زیاده روی در این امر مانع بروز خلاقیت تان
                      نشود. - انتقاد کننده از خود - ارزیابی نقاط قابل بهبود توسط
                      خودتان ویژگی مثبتی است به شرطی که خود و دیگران را سرزنش
                      نکنید.
                    </p>
                  </div>

                  <div className="w-full h-auto overflow-hidden border border-yellow-700 rounded-xl flex flex-col gap-3">
                    <h3 className="text-white bg-yellow-700 font-bold text-lg text-center py-3 border-b border-yellow-600">
                      بعد تاثیرگذاری : I
                    </h3>

                    <p className="text-gray-700 text-sm leading-6 p-3 pt-0 text-justify">
                      - مشتاق - شما با علاقه امور را پیگیری نموده و به گروه عشق
                      می ورزید ولی اطمینان بیش از حد تان موجب سوء استفاده دیگران
                      را فراهم می شود. - ارتباطی - شما با گروه به خوبی به منظور
                      انجام بهینه امور معاشرت می نماید ولی جهت استفاده از نظرات
                      دیگران باید قدری تامل داشته باشید. - متقاعد کننده - شما در
                      مجاب نمودن گروه و حرکت به سوی اهداف مشترک بسیار مجرب هستید
                      ، فقط مراقب باشید از ایجاد احساس فریب خوردن و سوء استفاده
                      قرار گرفتن در دیگران جلوگیری کنید. - تابع انگیزه آنی - شما
                      فردی علاقمند و خود انگیخته هستید ولی در اغلب موارد تکانشی
                      و بدون تامل کارها را انجام می دهید که این شانس موفقیت تان
                      را کم می کند. - هیجانی - شما بسیار احساساتی و پرشور می
                      باشید و در کلیه امور بی پرده اظهار نظر می کنید و افراط در
                      این ویژگی می تواند گروه را به دلیل احساس دخالت های بی جا
                      از شما دور کرد. - خود اظهارکننده - شما اطلاعاتی درباره خود
                      به دیگران داده و نظرات کارشناسی تان را ارائه می دهید. و
                      این اجازه می دهد که آن ها ، شما را به خوبی تجزیه و تحلیل
                      کرده و در مواقعی از فرایند امور کنار می گذارند. - اعتماد
                      کننده - اطمینان و حسن نیت شما به دیگران موجب ایجاد جو مثبت
                      در گروه است ولی اگر از حدی فراتر رود شما را ساده لوح می
                      پندارند.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* page 8 */}
            <div
              style={{ breakAfter: "page" }}
              className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
            >
              {/* frame */}
              <Frame page={8} user={testResult?.app ? testResult.app : user} />

              <div className="w-full flex flex-col gap-4 p-10 pt-28">
                <h2 className="text-3xl text-gray-800 font-black self-center my-3">
                  توصیف شاخص ابعاد DISC
                </h2>

                <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
                  <div className="w-full h-auto overflow-hidden border border-green-700 rounded-xl flex flex-col gap-3">
                    <h3 className="text-white bg-green-700 font-bold text-lg text-center py-3 border-b border-green-600">
                      بعد ثبات : S
                    </h3>

                    <p className="text-gray-700 text-sm leading-6 p-3 pt-0 text-justify">
                      سرعت پاسخ فرد به تغییر را می‌سنجد. شدت: هرچه مقدار « S »
                      کمتر باشد، تمایل فرد برای اتمام یکباره‌ی فعالیت بیشتر است.
                      همچنین هرچه مقدار « S » بالاتر باشد فرد در مقابل تغییر
                      بیشتر مقاومت می‌کند. هرچه مقدار « S » کمتر باشد، سرعت و
                      شدت تمایل فرد برای تغییر بیشتر است. هنگامی که فرد در محیط
                      ناخوشایندی قرار می‌گیرد مقدار بالای « S » در افراد باعث
                      بروز رفتاری بی‌تفاوت و بی‌احساس می‌شود. احساسات : فاکتور «
                      S » نبود احساس را اندازه می‌گیرد. هرچه فاکتور « S » در
                      افراد بیشتر باشد، فرد احساساتی‌تر و بیانگرتر خواهد بود و
                      هرچه مقدار« S » کمتر باشد، احساسات‌آن‌ها کمتر و شناخت
                      آن‌ها دشوارتر خواهد بود. بیشتر سئوال می کند کمتر حرف می
                      زند بیشتر گوش می کند نظرات خود را نگاه می دارد و بازخورد
                      نمی دهد. ارتباطات کلامی کمی دارد
                    </p>
                  </div>

                  <div className="w-full h-fit overflow-hidden border border-blue-700 rounded-xl flex flex-col gap-3">
                    <h3 className="text-white bg-blue-700 font-bold text-lg text-center py-3 border-b border-blue-600">
                      بعد وظیفه شناسی : C
                    </h3>

                    <p className="text-gray-700 text-sm leading-6 p-3 pt-0 text-justify">
                      - مؤدب - شما مبادی آداب بوده و بسیار رسمی رفتار می کنید که
                      این ویژگی می تواند، محیطی همراه با نزاکت و خوش آیند ایجاد
                      نماید ولی در صورت افراط شما را متملق و ریاکار تلقی می
                      نمایند. - محتاط - بررسی همه جانبه و احتیاط در امور ویژگی
                      بارز شماست که منتج به پیشگیری از اشتباهات شده ولیکن مراقب
                      بودن بیش از حد باعث تنبلی شده و مانع اتمام کارهای تان می
                      شود. - مراقب - گفتگوی حساب شده و امتناع شما از انتقاد،
                      ممکن است راستی و صداقت را در گروه افزایش دهد ولی با افراط
                      در این ویژگی، اختلافات مابین شما و گروه پنهان می ماند. -
                      دارای معیارهای بالا - شما برنامه هایی با استانداردهای بالا
                      طراحی می کنید که موجب رشد گروه می شود ولی فشار بیش از
                      حدتان در اجرای این معیارها روابط بین گروه را بهم می ریزد.
                      - تحلیل کننده - شما با منطق، تمام جوانب کار را سنجیده و
                      باعث افزایش دقت و کیفیت کارها می شوید. ولی افراط در این
                      ویژگی، خلاقیت تان را ذایل می گرداند. - حساس - شما با نکته
                      سنجی و حساسیت نقاط قوت و ضعف برنامه ها را به نحو احسن می
                      یابید ولیکن استفاده بیش از حد این ویژگی مانع پیشبرد امور
                      می شود. - کامل - جا افتادگی و عقلانیت شما ویژگی مناسبی
                      برای حل مسائل گروه است ولی عدم استفاده از خلاقیت و ایده
                      های جدید شما را همراهی گروه باز می دارد.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* page 9 */}
            <div
              style={{ breakAfter: "page" }}
              className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
            >
              {/* frame */}
              <Frame page={9} user={testResult?.app ? testResult.app : user} />

              <div className="w-full flex flex-col gap-4 p-10 pt-28">
                <h2 className="text-3xl text-gray-800 font-black self-center my-3">
                  نمودارها و الگوی رفتاری شما
                </h2>

                <p className="text-gray-700 px-10">
                  نمودارﻫﺎی DISC ﺷﻤﺎ در زﯾﺮ ﻧﻤﺎﯾﺶ داده ﺷﺪه اﺳﺖ، ﺑﺮ اﺳﺎس پاﺳﺦ ﻫﺎی
                  ﺗﺎن، ﻣﯿﺰان ﻫﺮکدام از اﺑﻌﺎد چهارگاﻧﻪ در ﻧﻤﻮدار ﻣﺸﺨﺺ ﺷﺪه اﺳﺖ ،
                  ﺗﻔﺴﯿﺮ و ﺗﺤﻠﯿﻞ ﻫﺎی اداﻣﻪ گزارش ﺑﺮ ﻣﺒﻨﺎی ﻫﻤﯿﻦ گراف ﺑﺪﺳﺖ آﻣﺪه
                  اﺳﺖ. ﺑﺎ ﻣﻄﺎﻟﻌﻪ اﯾﻦ گزارش ﺑﺎ ﻧﻘﺎط ﻗﻮت ، ﻗﺎﺑﻞ ﺑﻬﺒﻮد و الگوی
                  رﻓﺘﺎری ﺧﻮد آﺷﻨﺎ ﺧﻮاﻫﯿﺪ ﺷﺪ.
                </p>

                <h3 className="text-2xl self-center text-red-500 font-black">
                  {testResult.result.result.name}
                </h3>

                <div className="w-fit flex items-center self-center p-3 border border-gray-800 text-gray-800 rounded-xl">
                  کد سگمنت :{" "}
                  <div className="text-green-500 flex flex-row-reverse font-black text-xl">
                    {toFarsiNumber(testResult.result.line3[1].segment)}
                  </div>
                </div>

                <div className="w-full grid grid-cols-4 gap-4">
                  <div className="segment-chart relative">
                    <Chart
                      options={circleChartOption("#0d6efd").options}
                      series={[Math.round(testResult.result.line3[0].ci * 3.3)]}
                      type="radialBar"
                      height="235px"
                      width="100%"
                    />

                    <span className="absolute text-4xl text-gray-800 top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4">
                      {toFarsiNumber(
                        Math.round(testResult.result.line3[0].ci * 3.3)
                      )}
                    </span>
                  </div>

                  <div className="segment-chart relative">
                    <Chart
                      options={circleChartOption("#198754").options}
                      series={[Math.round(testResult.result.line3[0].si * 3.3)]}
                      type="radialBar"
                      height="235px"
                      width="100%"
                    />

                    <span className="absolute text-4xl text-gray-800 top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4">
                      {toFarsiNumber(
                        Math.round(testResult.result.line3[0].si * 3.3)
                      )}
                    </span>
                  </div>

                  <div className="segment-chart relative">
                    <Chart
                      options={circleChartOption("#ffc107").options}
                      series={[Math.round(testResult.result.line3[0].ii * 3.3)]}
                      type="radialBar"
                      height="235px"
                      width="100%"
                    />

                    <span className="absolute text-4xl text-gray-800 top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4">
                      {toFarsiNumber(
                        Math.round(testResult.result.line3[0].ii * 3.3)
                      )}
                    </span>
                  </div>

                  <div className="segment-chart relative">
                    <Chart
                      options={circleChartOption("#dc3545").options}
                      series={[Math.round(testResult.result.line3[0].di * 3.3)]}
                      type="radialBar"
                      height="235px"
                      width="100%"
                    />

                    <span className="absolute text-4xl text-gray-800 top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4">
                      {toFarsiNumber(
                        Math.round(testResult.result.line3[0].di * 3.3)
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* page 10 */}
            <div
              style={{ breakAfter: "page" }}
              className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
            >
              {/* frame */}
              <Frame page={10} user={testResult?.app ? testResult.app : user} />

              <div className="w-full flex flex-col items-center gap-4 p-10 pt-28">
                <h2 className="text-3xl text-gray-800 font-black self-center my-3">
                  نمودارها و توضیحات مربوطه
                </h2>

                <div className="w-full grid grid-cols-2 gap-4">
                  <div className="flex w-full col-span-2 justify-center">
                    <div className="segment-chart w-[349px] flex flex-col justify-center bg-white border border-gray-300 p-3 rounded-xl items-center gap-3 relative">
                      <div className="text-gray-800 font-black text-lg">
                        نمودار اصلی
                      </div>
                      <Chart
                        options={anlayse.options}
                        series={[
                          {
                            data: [
                              Math.round(testResult.result.line3[0].di * 3.3),
                              Math.round(testResult.result.line3[0].ii * 3.3),
                              Math.round(testResult.result.line3[0].si * 3.3),
                              Math.round(testResult.result.line3[0].ci * 3.3),
                            ],
                          },
                        ]}
                        type="line"
                        height={200}
                      />

                      <p className="text-sm -mt-4 text-gray-700">
                        این نمودار مهم‌ترین و اصلی‌ترین نمودار تست DISC است.
                        درواقع الگوی رفتاری شما بر اساس اعداد این نمودار محاسبه
                        می شود. مثلا اگر در این نمودار، D شما برابر با ۵۶% باشد
                        یعنی اینکه شما ۵۶ درصد از رفتارهای مربوط به لایه D را
                        دارید و ۴۴ درصدش را ندارید.
                      </p>
                    </div>
                  </div>

                  <div className="segment-chart flex flex-col bg-white border border-gray-300 p-3 rounded-xl items-center gap-3 relative">
                    <div className="text-gray-800 font-black text-lg">
                      نمودار تطبیق یافته
                    </div>
                    <Chart
                      options={anlayse.options}
                      series={[
                        {
                          data: [
                            Math.round(testResult.result.line1[0].di * 3.3),
                            Math.round(testResult.result.line1[0].ii * 3.3),
                            Math.round(testResult.result.line1[0].si * 3.3),
                            Math.round(testResult.result.line1[0].ci * 3.3),
                          ],
                        },
                      ]}
                      type="line"
                      height={200}
                    />

                    <p className="text-sm -mt-4 text-gray-700">
                      این نمودار به نقاب اجتماعی هم معروف است یعنی چیزی که
                      دیگران از شما می‌بینند . معمولا نمودار تطبیق‌یافته ٫
                      معمولا درصد تغییر بیشتری نسبت به نمودار طبیعی دارد و غالبا
                      برای ارتباطات روزمره و سطحی‌تر مثل ارتباطات کاری، مذاکرات
                      تجاری، ارتباطات دوستانه و… استفاده می شود.
                    </p>
                  </div>

                  <div className="segment-chart flex flex-col bg-white border border-gray-300 p-3 rounded-xl items-center gap-3 relative">
                    <div className="text-gray-800 font-black text-lg">
                      نمودار طبیعی
                    </div>
                    <Chart
                      options={anlayse.options}
                      series={[
                        {
                          data: [
                            Math.round(testResult.result.line2[0].di * 3.3),
                            Math.round(testResult.result.line2[0].ii * 3.3),
                            Math.round(testResult.result.line2[0].si * 3.3),
                            Math.round(testResult.result.line2[0].ci * 3.3),
                          ],
                        },
                      ]}
                      type="line"
                      height={200}
                    />

                    <p className="text-sm -mt-4 text-gray-700">
                      نمودار طبیعی که به ان نمودار ذاتی هم می گویند، نموداری است
                      که رفتارهای عمیق شمارا بیان میکند و معمولا برای ارتباطات
                      با عمق بیشتر مثل ازدواج و فرزندپروری کارایی دارد. (البته
                      که باید این موضوع را بدانید که این نمودار به شخصیت درونی
                      انسان ربطی نداشته و شخصیت فرد موضوع متفاوتی است)
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <ResultWrapper result={testResult} />

            {/* page 24 */}
            <div
              style={{ breakAfter: "page" }}
              className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
            >
              {/* frame */}
              <Frame page={24} user={testResult?.app ? testResult.app : user} />

              <div className="w-full flex flex-col gap-4 p-10 pt-28">
                <h2 className="text-3xl text-gray-800 font-black self-center my-3">
                  الگوهای رفتاری
                </h2>

                <p className="text-gray-700">
                  در این بخش می خواهیم چهار نوع الگوی رفتاری مختلف را معرفی کنیم
                  که هر انسان ترکیبی منحصر به فرد از این چهار الگو می باشد. برای
                  درک بهتر این قضیه اجازه دهید ابتدا نمودار گرافیکی رفتاری را با
                  هم ترسیم کنیم. شکل شماره یک نقشه ابتدایی ماست که در طول گزارش
                  آن را با هم کامل و کامل تر خواهیم کرد و اجزای آن را به تفضیل
                  خواهیم شناخت .
                </p>

                <div className="flex flex-col justify-center items-center gap-2">
                  <img src={circle} className="w-40 rounded-full" alt="" />
                  <span className="text-gray-600">
                    شکل یک : نمای کلی نمودار
                  </span>
                </div>

                <p className="text-gray-700">
                  آن چه در همین ابتدای مسیر به عنوان قانون اصلی لازم است بشناسیم
                  این است که در میان چهار الگوی مذکور خوب یا بد ، درست یا غلط ،
                  بهتر یا بدتر وجود ندارد. بلکه هر چهار الگوی مذکور در جای خود
                  لازم و حائز اهمیت می باشند. برای اینکه معنی و مفهوم کلی الگو
                  را به درستی درک کنیم اجازه دهید در ابتدا نمودار خود را در جهات
                  مناسب برش بزنیم و طبقه بندی های کلی از الگو و کارکترهای افراد
                  ارائه دهیم .
                </p>

                <h3 className="text-2xl font-bold text-gray-800">
                  قدم اول : تقسیم بندی افقی نمودار (افراد برون گرا - درون گرا)
                </h3>

                <p className="text-gray-700 text-[15px]">
                  اگر نمودار خود را به صورت افقی برش بزنیم نیمه بالایی آن را
                  افرادی سریع، جسور ، خوش بین ، فعال و اجتماعی تشکیل می دهند.
                  این گروه با فعل " رفتن " رابطه مستقیم دارند و رفتن و حرکت در
                  خون آن هاست. آنها عاشق حرکت هستند. فقط کافی است به آنها بگوید
                  " می خواهیم بریم به ... " قطعا جواب شان آری خواهد بود. اصلا به
                  این نیاندیشید که جایی که می خواهید بروید واقعا" عالی است یا نه
                  چون این افراد آن را عالی خواهند ساخت. این ها در جستجوی شور و
                  هیجان بوده و آن را خلق خواهند کرد. آنها مهمانی های شان را هر
                  کجا که باشد برگزار کرده و پر انرژی و سریع هستند و تمایل دارند
                  کارهای شان را با سرعت زیادی انجام دهند. وقتی با افرادی به
                  رستوران رفتید و درحالی که شما در حال خوردن سالاد هستید آنها در
                  جستجوی دسر بعد از غذا هستند، شک نکنید که ایشان به نیمه بالایی
                  نمودار تعلق دارند. افراد بالای نمودار رقابت طلب بوده و معمولا
                  در نقش یک رهبر و محرک در راس امور ظاهر می شوند. نه به خاطر این
                  که دوست دارند کار کنند بلکه به خاطر این که آنها از صمیم قلب
                  علاقه دارند به دیگران بگویند چه کار کنند. این افراد عموما
                  ا  به نفس خوبی دارند و از دید قدرت به دیگران نگاه
                  می کنند. این گروه عموما خودشان را از محیط قوی تر و برتر دیده و
                  راسخ و جسور هستند. در اصطلاح در این جا افراد نیمه بالایی
                  نمودار را افرادی " برون گرا " می خوانیم.
                </p>
              </div>
            </div>

            {/* page 25 */}
            <div
              style={{ breakAfter: "page" }}
              className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
            >
              {/* frame */}
              <Frame page={25} user={testResult?.app ? testResult.app : user} />

              <div className="w-full flex flex-col gap-4 p-10 pt-32">
                <p className="text-gray-700 text-[15px]">
                  اما افراد پان نمودار افرادی محتاط ، آرام ، اهل تفکر، عادل ،
                  تحلیلگر و واقع بین هستند. آنها تمایل به تثبیت موقعیت موجود
                  داشته و صبر و استقامت زیادی دارند. این گروه مهربان، ریزبین و
                  دقیق هستند. در واقع به آرام بودن این گروه برای قضاوت اکتفا
                  نکنید زیرا آنها مانند مثال معروف لاک پشتی هستند که با خرگوش
                  سریع و جسور به رقابت پرداخته و آهسته و پیوسته به مسیر خود
                  ادامه می دهند و خط پایان را پشت سر می گذارند. افراد پان
                  نمودار عموما تمایلی ندارند در راس امور باشند و ترجیح می دهند
                  پشت صحنه را به بهترین نحو اداره کنند و از درست بودن همه امور
                  مطمئن شوند. این گروه روابط ظاهری را دوست ندارند و اغلب برای
                  شان سخت است که دوستان زیادی داشته باشند بلکه تمایل دارند یک یا
                  دو دوست صمیمی داشته باشند و در کنار آنها لذت ببرند. در اصطلاح
                  در این جا افراد نیمه پان نمودار را افرادی " درون گرا " می
                  خوانیم.
                </p>

                <div className="flex flex-col justify-center items-center gap-2">
                  <img src={circle2} className="w-40" alt="" />
                  <span className="text-gray-600">
                    شکل دو : نمای کلی نمودار
                  </span>
                </div>

                <h3 className="text-2xl font-bold text-gray-800">
                  قدم دوم : تقسيم بندی عمودی نمودار (افراد وظيفه محور – مردم
                  محور)
                </h3>

                <p className="text-gray-700">
                  اجازه دهيد اين بار نمودار الگوي رفتاري را در دو بخش عمودي
                  تقسيم كرده و ويژگي هاي مجزا از شخصيت هاي افراد را ارائه دهيم.
                  افراد سمت چپ نمودار را افراد وظيفه محور و افراد سمت راست
                  نمودار را افراد مردم محور تشكيل مي دهند.
                </p>

                <div className="flex flex-col justify-center items-center gap-2">
                  <img src={circle3} className="w-40" alt="" />
                  <span className="text-gray-600">
                    شکل سه : نمای کلی نمودار
                  </span>
                </div>

                <p className="text-gray-700">
                  افراد نیمه پان و چپ نمودار که افرادی درون گرا و وظیفه محور
                  هستند و آنها را به اختصار گروه C می نامیم.C ابتدای کلمات محتاط
                  (cautious)،حسابگر(calculating)،شایسته (competent)، وظیفه شناس
                  (Conscientious)، با وجدان و دقیق ( careful)است.
                </p>
              </div>
            </div>

            {/* page 26 */}
            <div
              style={{ breakAfter: "page" }}
              className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
            >
              {/* frame */}
              <Frame page={26} user={testResult?.app ? testResult.app : user} />

              <div className="w-full flex flex-col gap-4 p-10 pt-32">
                <p className="text-gray-700">
                  بگذاريد براي درك بهتر موضوع با يك مثال ساده مسئله را تشريح
                  كنيم و فرض كنيد يك روز صبح تعطيل، شخصي تصميم مي گيرد باغچه هاي
                  حياط بيروني خود را مرتب كند. افراد سمت چپ نمودار ( وظيفه محور)
                  ابتدا با تجهيزات كامل از منزل بيرون آمده و به شن كش خود تكيه
                  می دهند و كل حياط را نظاره مي كنند. سپس شروع به كار كرده و
                  بخشي از آن را انجام مي دهند و اگر نتيجه كار دلخواه شان بود آن
                  را ادامه مي دهند. بعضی از اعضاي اين گروه ممكن است از افرادي
                  كمك گرفته تا حياط را براي شان مرتب كنند مشروط بر اين كه تنها
                  كاركنند و کار کنند و کار کنند! در حالي كه افراد سمت راست
                  نمودار ابتدا با يك كلاه آفتابي حصيري زيبا وارد حياط شده و هواي
                  تازه را استشمام مي كنند. حتي اگر ديديد آنها با لبخند به موسيقي
                  دلنواز گوش مي دهند يا براي پرنده ها دست تكان مي دهند تعجب
                  نكنيد. آنها در حين كار با طراوت آواز می خوانند و دركل زمان به
                  احساس خوبي كه باغچه زيباي شان بر مردم مي گذرد مي انديشند. اين
                  گروه اگر همسايه خود را ببيند با او مشغول صحبت شده و حتي وي را
                  به خانه دعوت مي كنند. تا با هم قهوه بخورند! زيرا آنها متعقدند
                  براي كار كردن وقت هست اما ديدار يك آشنا يا همدردي با خانم مسن
                  همسايه در حالي كه به او نياز دارد شايد هميشه تكرار نشود. اين
                  در حالي است كه اگر همين همسايه نزد افراد گروه وظيفه محور برود
                  تنها با سلامي ساده مواجه مي شود. اگر ایشان تمايلي به صحبت كردن
                  بيشتر نشان دهند. قطعا وظيفه محور ها حرف آنها را قطع كرده و پس
                  از چند لحظه با يك شن كش ديگر از خانه برمي گردند. زيرا آنها مي
                  انديشند اگر تمايل دارد به حرف زدن ادامه دهد مي تواند در انجام
                  كارهايم به من كمك كند!
                </p>

                <h3 className="text-2xl font-bold text-gray-800">
                  قدم سوم شناخت چهار الگوي رفتاري :
                </h3>

                <p className="self-center text-gray-600">
                  حال اگر دو برش افقی و عمودی نمودار را با هم ترکیب کنید ، می
                  توانید چهار الگوی رفتاری را ببینید .
                </p>

                <img src={discImg5} className="self-center" alt="" />
              </div>
            </div>

            {/* page 27 */}
            <div
              style={{ breakAfter: "page" }}
              className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
            >
              {/* frame */}
              <Frame page={27} user={testResult?.app ? testResult.app : user} />

              <div className="w-full flex flex-col gap-4 p-10 pt-32">
                <p className="text-gray-700">
                  اکنون با شناخت و ترکیب چهار الگوی فوق ، نمودار زیر که مرجع کلی
                  و نقشه ما در راه شناخت کاراکترهای رفتاری افراد در طول مسیر
                  خواهد بود بدست می آید .
                </p>

                <div className="grid grid-cols-1 gap-4">
                  <div className="w-full overflow-hidden h-fit border border-red-700 rounded-xl flex flex-col gap-3">
                    <h3 className="text-white font-bold bg-red-700 md:text-lg px-3 py-3 border-b border-red-700">
                      گروه اول - گروه D :
                    </h3>

                    <p className="text-gray-700 p-3 pt-0 text-justify">
                      افراد نیمه بالا و چپ نمودار که افرادی برون گرا و وظیفه
                      محور هستند و آنها را به اختصار گروه " D " می نامیم .D
                      ابتدای کلمات تسلط (Dominate)، هدایت کردن (Direct)،
                      مصر(Demanding)، قاطع (Decisive)و نماینده (Doer) است .
                    </p>
                  </div>

                  <div className="w-full overflow-hidden h-auto border border-yellow-700 rounded-xl flex flex-col gap-3">
                    <h3 className="text-white font-bold md:text-lg bg-yellow-700 px-3 py-3 border-b border-yellow-700">
                      گروه دوم - گروه I :
                    </h3>

                    <p className="text-gray-700 p-3 pt-0 text-justify">
                      افراد نیمه بالا و راست نمودار که افرادی برون گرا و مردم
                      محور هستند و آنها را به اختصار گروه " I " می نامیم . I
                      ابتدای کلمات الهام بخش(inspiring)، تاثیر
                      گذار(influencing)، برانگیزاننده(impressive)و علاقه مند به
                      مردم و اجتماعی (people in interested) است .
                    </p>
                  </div>

                  <div className="w-full overflow-hidden h-fit border border-green-700 rounded-xl flex flex-col gap-3">
                    <h3 className="text-white font-bold md:text-lg px-3 bg-green-700 py-3 border-b border-green-700">
                      گروه سوم _ گروه S :
                    </h3>

                    <p className="text-gray-700 p-3 pt-0 text-justify">
                      افراد نیمه پان و راست نمودار که افرادی درون گرا و مردم
                      محور هستند و آنها را به اختصار گروه S می نامیم.S ابتدای
                      کلمات حامی و پشتیبان(supportive)،ثبات(stable)،خوش برخورد و
                      دلنشین(sweet) خجالتی(shy)است.
                    </p>
                  </div>

                  <div className="w-full overflow-hidden h-fit border border-blue-700 rounded-xl flex flex-col gap-3">
                    <h3 className="text-white font-bold md:text-lg bg-blue-700 px-3 py-3 border-b border-blue-700">
                      گروه چهارم _ گروه C :
                    </h3>

                    <p className="text-gray-700 p-3 pt-0 text-justify">
                      افراد نیمه پان و چپ نمودار که افرادی درون گرا و وظیفه
                      محور هستند و آنها را به اختصار گروه C می نامیم.C ابتدای
                      کلمات محتاط (cautious)،حسابگر(calculating)،شایسته
                      (competent)، وظیفه شناس (Conscientious)، با وجدان و دقیق (
                      careful)است.
                    </p>
                  </div>
                </div>
              </div>
            </div>

             <div
              style={{ breakAfter: "page" }}
              className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
            >
              {/* frame */}
              <Frame page={27} user={testResult?.app ? testResult.app : user} />

              <div className="w-full flex flex-col gap-4 p-10 pt-32">
                <p className="leading-7 text-gray-800">
                  اگر تا این لحظه با ما همراه بوده اید ، بسیار خوشحالیم و اگر در
                  ذهن خود ، دیگران و خودتان را تجزیه تحلیل کرده و با الگوهای فوق
                  مقایسه نموده اید به شما تبریک می گوئیم . زیرا شما اکنون نقشه
                  مسیری را دارید که دیگران باید با تلاش مضاعف آن را دریابند .
                  فقط ممکن است با خود اندیشیده باشید که شما بخشی از همه این
                  خصوصیات را در خود دارید . اگر چنین نتیجه ای گرفته اید اصلا
                  نگران نباشید . زیرا تحقیقات نشان می دهد %80 مردم عمدتا در دو
                  حوزه ممکن است نسبت به سایر حوزه ها قوی تر باشند و شما هم الگوی
                  منحصر به فردی از ترکیب این چهار الگوی مطرح شده هستید. اما برای
                  قضاوت صحیح نسبت به الگوی رفتاری خود یا سایرین کمی صبر کنید و
                  در ادامه مسیر با ما همراه باشید تا شناخت خود را نسبت به هر
                  کدام از آنها قوی تر نمائید .
                </p>
              </div>
            </div>

            {/* page 28 */}
            <div
              style={{ breakAfter: "page" }}
              className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
            >
              {/* frame */}
              <Frame page={28} user={testResult?.app ? testResult.app : user} />

              <div className="w-full flex flex-col gap-4 p-10 pt-28">
                <h2 className="text-3xl text-gray-800 font-black self-center my-3">
                  تمایلات این افراد شامل موارد ذیل است
                </h2>

                <div className="relative">
                  <img
                    src={discImg6}
                    className="self-center px-16 mt-5"
                    alt=""
                  />

                  <div className=""></div>
                </div>
              </div>
            </div>

            {/* page 29 */}
            <div
              style={{ breakAfter: "page" }}
              className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
            >
              {/* frame */}
              <Frame page={29} user={testResult?.app ? testResult.app : user} />

              <div className="w-full flex flex-col gap-4 p-10 pt-28">
                <h2 className="text-3xl text-gray-800 font-black self-center my-3">
                  این افراد طالب محیطی هستند که در آن
                </h2>

                <img src={discImg7} className="self-center px-16 mt-5" alt="" />
              </div>
            </div>

            {/* page 30 */}
            <div
              style={{ breakAfter: "page" }}
              className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
            >
              {/* frame */}
              <Frame page={30} user={testResult?.app ? testResult.app : user} />

              <div className="w-full flex flex-col gap-4 p-10 pt-28">
                <h2 className="text-3xl text-gray-800 font-black self-center my-3">
                  این اشخاص به افرادی با خصوصیات ذیل احتیاج دارند که
                </h2>

                <img src={discImg8} className="self-center px-16 mt-5" alt="" />
              </div>
            </div>

            {/* page 31 */}
            <div
              style={{ breakAfter: "page" }}
              className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
            >
              {/* frame */}
              <Frame page={31} user={testResult?.app ? testResult.app : user} />

              <div className="w-full flex flex-col gap-4 p-10 pt-28">
                <h2 className="text-3xl text-gray-800 font-black self-center my-3">
                  برای موثرتر بودن ، این افراد نیاز دارند که
                </h2>

                <img src={discImg9} className="self-center px-16 mt-5" alt="" />
              </div>
            </div>

            {/* page 32 */}
            <div
              style={{ breakAfter: "page" }}
              className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
            >
              {/* frame */}
              <Frame page={32} user={testResult?.app ? testResult.app : user} />

              <div className="w-full flex flex-col gap-4 p-10 pt-28">
                <h2 className="text-3xl text-gray-800 font-black self-center my-3">
                  برای افزایش سازگاری رفتاری نیاز دارند که
                </h2>

                <img
                  src={discImg10}
                  className="self-center px-16 mt-5"
                  alt=""
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DiscResult;
